import type { DocumentNode } from 'graphql';
import { Kind } from 'graphql/language/kinds';

export function documentName(document: DocumentNode): string {
    for (const def of document.definitions) {
        if (def.kind === Kind.OPERATION_DEFINITION) {
            return def.name?.value ?? 'unknown';
        }
    }

    return 'unknown';
}
